import PropTypes from "prop-types";
import React from "react";
import { primary, lightestBlue, lightRed, red, darkSkyBlue } from "@govlaunch/palette";

export default function TagsMenu({ children, validationState, ...props }) {
  return (
    <div
      css={{
        ...containerStyle,
        ...(validationState === "error" && errorContainerStyle),
      }}
      {...props}
    >
      <div
        css={{
          ...arrowStyle,
          ...(validationState === "error" && errorArrowStyle),
        }}
      />
      {children}
    </div>
  );
}

TagsMenu.propTypes = {
  validationState: PropTypes.string,
  children: PropTypes.any.isRequired,
};

TagsMenu.defaultProps = {
  validationState: null,
};

const errorContainerStyle = {
  borderLeft: `solid 1px ${red}`,
  borderRight: `solid 1px ${red}`,
  borderBottom: `solid 1px ${red}`,
  backgroundColor: lightRed,
  color: red,
};

const containerStyle = {
  backgroundColor: lightestBlue,
  fontSize: 12,
  fontWeight: 500,
  paddingLeft: 10,
  paddingBottom: 10,
  color: primary,
  borderLeft: `solid 1px ${darkSkyBlue}`,
  borderRight: `solid 1px ${darkSkyBlue}`,
  borderBottom: `solid 1px ${darkSkyBlue}`,
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
  position: "absolute",
  width: "100%",
  boxSizing: "border-box",
};

const errorArrowStyle = {
  borderColor: `transparent transparent ${lightRed} transparent`,
};

const arrowStyle = {
  width: 0,
  height: 0,
  borderStyle: "solid",
  borderWidth: "0 7px 8px 7px",
  borderColor: `transparent transparent ${lightestBlue} transparent`,
  position: "absolute",
  top: 0,
  left: 0,
  marginTop: -6,
  marginLeft: 20,
};
